import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Impact = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Impact' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M13,2 L22,6 L22,17 L13,22 L13,2 Z M22,6 L13,11 L22,6 Z M9,22 L9,2 L9,22 Z M9,12 L3,5 L9,12 Z M9,12 L1,12 L9,12 Z M9,12 L3,19 L9,12 Z' />
  </StyledIcon>
);
